import { patch } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useAssignCourierToOrdersMutation = () => {
  const { t } = useTranslation();
  const branchId = useBranchId();

  const mutation = useMutation({
    mutationFn: ({ orders, courierId, pin_code }: any) =>
      patch(
        `/internal/secure/pos/v1/orders/information/couriers/assign/multiple/orders/to/courier/id/${branchId}/${courierId}`,
        {
          orders,
          pin_code,
        }
      ),
    onSuccess: () => {
      toast.success(t("success.update"));
    },
  });

  return mutation;
};

export default useAssignCourierToOrdersMutation;
